import React from 'react';
import { Link } from 'react-router-dom';

const AboutHero: React.FC = () => {
  return (
    <section className="relative min-h-[70vh] flex items-center justify-center overflow-hidden pt-32 pb-20">
      {/* Background Image with Overlay */}
      <div 
        className="absolute inset-0 bg-cover bg-center bg-no-repeat"
        style={{
          backgroundImage: `url(${encodeURI('/assets/img/nfotos/Dr Dieter con .jpg')})`,
        }}
      >
        {/* Dark overlay for better readability */}
        <div className="absolute inset-0 bg-black/70"></div>
      </div>

      {/* Decorative Elements */}
      <div className="absolute top-20 left-10 w-32 h-32 bg-secondary/10 rounded-full blur-3xl animate-float"></div>
      <div className="absolute bottom-20 right-10 w-40 h-40 bg-primary/10 rounded-full blur-3xl animate-float" style={{ animationDelay: '1s' }}></div>

      {/* Content */}
      <div className="container-custom relative z-10 py-12">
        {/* Breadcrumb - Centered */}
        <div className="flex items-center justify-center gap-2 text-sm text-white/80 mb-8 animate-fadeIn">
          <Link 
            to="/" 
            className="hover:text-secondary transition-colors duration-300 flex items-center gap-1"
          >
            Home
          </Link>
          <svg className="w-4 h-4" fill="none" stroke="currentColor" viewBox="0 0 24 24">
            <path strokeLinecap="round" strokeLinejoin="round" strokeWidth={2} d="M9 5l7 7-7 7" />
          </svg>
          <span className="text-secondary font-medium">Quem Somos</span>
        </div>

        {/* Title and Description - Centered */}
        <div className="max-w-4xl mx-auto text-center">
          <h1 className="text-5xl md:text-6xl lg:text-7xl font-serif font-bold text-white mb-6 leading-tight">
            Onde a <span className="text-transparent bg-clip-text bg-gradient-to-r from-secondary to-primary">beleza natural</span> encontra a excelência
          </h1>
          
          <p className="text-lg md:text-xl text-white/90 leading-relaxed max-w-2xl mb-8 mx-auto">
            Desde 2021 transformando vidas através da harmonização facial e tratamentos estéticos de alta performance. Nossa assinatura é a naturalidade que valoriza a essência única de cada cliente.
          </p>

          {/* Stats Grid - Centered */}
          <div className="grid grid-cols-2 md:grid-cols-4 gap-6 mt-12 max-w-5xl mx-auto">
            <div className="group">
              <div className="bg-white/10 backdrop-blur-md rounded-2xl p-6 border border-white/20 hover:bg-white/20 transition-all duration-300 hover:scale-105">
                <div className="text-4xl font-bold text-secondary mb-2">5000+</div>
                <div className="text-sm text-white/80 uppercase tracking-wider">Clientes</div>
              </div>
            </div>
            
            <div className="group">
              <div className="bg-white/10 backdrop-blur-md rounded-2xl p-6 border border-white/20 hover:bg-white/20 transition-all duration-300 hover:scale-105">
                <div className="text-4xl font-bold text-secondary mb-2">4+</div>
                <div className="text-sm text-white/80 uppercase tracking-wider">Anos</div>
              </div>
            </div>
            
            <div className="group">
              <div className="bg-white/10 backdrop-blur-md rounded-2xl p-6 border border-white/20 hover:bg-white/20 transition-all duration-300 hover:scale-105">
                <div className="text-4xl font-bold text-secondary mb-2">2</div>
                <div className="text-sm text-white/80 uppercase tracking-wider">Unidades</div>
              </div>
            </div>
            
            <div className="group">
              <div className="bg-white/10 backdrop-blur-md rounded-2xl p-6 border border-white/20 hover:bg-white/20 transition-all duration-300 hover:scale-105">
                <div className="text-4xl font-bold text-secondary mb-2">100%</div>
                <div className="text-sm text-white/80 uppercase tracking-wider">Dedicação</div>
              </div>
            </div>
          </div>
        </div>
      </div>

      {/* Bottom Gradient */}
      <div className="absolute bottom-0 left-0 right-0 h-32 bg-gradient-to-t from-white to-transparent"></div>
    </section>
  );
};

export default AboutHero;
